/**
 * Checks if the provided value is the "all" value (ALL_VALUE).
 * @param value - The value to check.
 * @returns True if value is ALL_VALUE, otherwise false.
 */
import { ALL_VALUE } from "../constants";
import type { AllValueType } from "../types/ui";

export function colorToAlpha(color: string, alpha?: number) {
    const alphaVal = alpha ?? 1;

    if (color.includes("rgba")) {
        const rgb = color.replace("(", "").replace(")", "").split("rgba")[1].split(",");
        return `rgba(${rgb[0].trim()}, ${rgb[1].trim()}, ${rgb[2].trim()}, ${alphaVal})`;
    }

    if (color.includes("rgb")) {
        const rgb = color.replace("(", "").replace(")", "").split("rgb")[1].split(",");
        return `rgba(${rgb[0].trim()}, ${rgb[1].trim()}, ${rgb[2].trim()}, ${alphaVal})`;
    }

    if (color.startsWith("#")) {
        const r = parseInt(color.slice(1, 3), 16);
        const g = parseInt(color.slice(3, 5), 16);
        const b = parseInt(color.slice(5, 7), 16);

        return `rgba(${r}, ${g}, ${b}, ${alphaVal})`;
    }

    return color;
}

export function textContains(val: string | string[], search: string) {
    const text = typeof val === "string" ? val : val.join("");

    // Original behavior (explicitly preserved): alphanumeric-only search
    const safeSearch = search.replace(/[^a-zA-Z0-9]/g, "").trim();
    const primaryMatch = text.replace(`\\`, "").search(new RegExp(safeSearch, "i")) !== -1;
    if (primaryMatch) return true;

    // If the query includes any non-alphanumeric chars (e.g., '-' '+'),
    // require a literal match of what the user typed
    const hasNonAlnum = /[^a-zA-Z0-9]/.test(search);
    if (hasNonAlnum) {
        const q = search.trim();
        if (!q) return true;
        const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const literalPattern = new RegExp(escapeRegExp(q), "i");
        return literalPattern.test(text);
    }

    return false;
}

export function isAll(value: unknown): value is AllValueType {
    return value === ALL_VALUE;
}
